import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

export interface WorkUiProgressStepInterface {
  label: string;
  completed?: boolean;
}

export type WorkUiProgressStepsAlignment = 'horizontal' | 'vertical';

@Component({
  selector: 'work-ui-progress-steps',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './progress-steps.component.html',
  styleUrl: './progress-steps.component.scss',
})
export class ProgressStepsComponent {
  steps = input<WorkUiProgressStepInterface[]>([]);
  activeStep = input<number>(0);
  alignment = input<WorkUiProgressStepsAlignment>('horizontal');
}
